module.exports = __webpack_public_path__ + "static/screenshot-iphone12-three-01cda47254644a57e6f6139e490f1062.png";